import axios from "axios";
import ConstantList from "../../appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/etb/list-tests-waiting-for-results";

export const countTotalInTab = (searchObject) => {
  var url = API_PATH + "/count-total-in-tab";
  return axios.post(url, searchObject);
};

export const getByLabTestLogin = (searchObject) => {
  var url = API_PATH + "/get-by-lab-test-login";
  return axios.post(url, searchObject);
};

export const getLabTestWaitingResult = (id) => {
  var url = API_PATH + "/get-lab-test-by-id-request/" + id;
  return axios.get(url);
};

export const saveClinicalServiceRequest = (obj, id) => {
  var url = API_PATH + "/save-clinical-service-request/" + id;
  return axios.post(url, obj);
};

export const getEtbServiceItemObsHiv = (id) => {
  var url = API_PATH + "/get-etb-service-item-obs-hiv/" + id;
  return axios.get(url);
};